import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SharedService {

  private data = new BehaviorSubject(undefined);
  sharedData = this.data.asObservable();

  constructor() { }

  nextData(data: any) {
    this.data.next(data)
  }
  
}


// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/services/core/shared.service.ts